import React, { useState, useRef, useEffect } from "react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";

import formatDateForInput from "../assets/formatDateForInput";
import "react-datepicker/dist/react-datepicker.css";
import { useForm, FormProvider, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";


import api from "../api/api"
import { useAuth } from "../context/AuthContext";


import { schema1, schema2, schema3, schema4 } from "../schema/schemaBiodata";

import { Link, useLocation, useHistory } from "react-router-dom";
import FormBiodata from "./components/FormBiodata";
import { useTranslation } from 'react-i18next';


const BiodataForm = () => {

    const location = useLocation();
    const { t } = useTranslation();
    const [biodata, setBiodata] = useState(location.state?.biodata ? location.state.biodata : null);



    const { user } = useAuth()
    const steps = [
        { id: 1, title: "Profile of FDW", icon: "far fa-user" },
        { id: 2, title: "Personal Information", icon: "fas fa-stethoscope" },
        { id: 3, title: "Medical History/Dietary Restriction", icon: "fas fa-users" },
        { id: 4, title: "Skills of FDW", icon: "fas fa-briefcase" },
    ];


    const [stepManualErrors, setStepManualErrors] = useState({});
    const stepSchemas = [schema1(t), schema2(t), schema3(t), schema4(t)]
    const [currentStep, setCurrentStep] = useState(1);

    useEffect(() => {
        //async function instantcheck() {
         //   await trigger();
        //}
        //instantcheck()
        
        if (currentStep !== currentStep.length && submitForce == true) {

            setSubmitForce(false)
        }
    }, [currentStep])

    const nextStep = async () => {




        const isValid = await trigger(); // Validate only current step

       


        
      

        setStepManualErrors((prevErrors) => ({
            ...prevErrors,
            [currentStep]: isValid, // Store validation result for the step
        }));
      

        if (currentStep === stepSchemas.length) {


            return
        }
        // Blockit
          if (isValid) {
        setCurrentStep((prev) => prev + 1);
          }
    };

    const prevStep = () => {
        setCurrentStep((prev) => prev - 1);
    };



    const [menu, setMenu] = useState(false);

    const toggleMobileMenu = () => {
        setMenu(!menu);
    };
    const targetButtonRefs = useRef([]);

       


    let methods;
    if (biodata) {
        delete biodata.age;
        console.log("Biodata:", biodata.employment);
        
  
        methods = useForm({
            resolver: yupResolver(stepSchemas[currentStep - 1]), mode: "onBlur", defaultValues: {

              ...Object.fromEntries(
      Object.entries(biodata).map(([k, v]) => [k, v == null ? "" : v])
    ),

                children: biodata.enfants,
                dob: formatDateForInput(biodata.dob),
                imgprofile: null,
                //set fields to empty if they are 0 
                
                height: biodata.height == 0 ? "" : biodata.height,
                weight: biodata.weight == 0 ? "" : biodata.weight,
                contact: biodata.contact ? biodata.contact : ""



            },
        })
    } else {
        methods = useForm({
            resolver: yupResolver(stepSchemas[currentStep - 1]), mode: "onBlur", defaultValues: {

                name: "",
                imgprofile: null,

                dob: null,
                pob: "",
                //age: 0,
                nationality: "",
                //height: 0,
                //weight: 0,
                address: "",
                airport: "",
                contact: "",
                religion: "",
                // siblings: 0,
                education: '',
                marital: "", 
                passport: "",
                salary: 0,
                children: 0,
                children_age: [],
                
                interview_availability: [],
                allergies: "",
                selectedIllnesses: [],
                interview_method: [],
                illnesses: [],
                employment: [],
                other_skills:"",
                overseas_training: false,
                singapore_ea: false,
                fdw_declaration: false,
                food_preference: { pork: false, beef: false, other: "" },
                passport_check: false,
                singapore_experience: "",
                languages: [] ,
                code: "",



            },
        })
    }
    const { handleSubmit, control, clearErrors, reset, register, watch, setError, setValue, trigger, formState: { errors } } = methods;
    useEffect(() => {
        console.log("Current errors:", errors);
    }, [errors]);


    //const singaporeExperience = watch("singapore_experience"); // Track the selected option







    //to save type of submit
    const submitTypeRef = useRef(null);



    const [showDraftSaved, setShowDraftSaved] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowDraftSaved(false);
        }, 1900); // 3 seconds

        return () => clearTimeout(timer); // clean up
    }, [showDraftSaved]);



    const [submitForce, setSubmitForce] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(false);
    const [loadingForm, setLoadingForm] = useState(false);
    const [loadingFormDraft, setLoadingFormDraft] = useState(false);
    const onSubmit = async (data, e) => {




        
        const isValid = await trigger(); 
     
        if(!isValid)return

        const submitType = e.nativeEvent.submitter.dataset.type;
        submitTypeRef.current = submitType




        if (submitType !== "Published" && submitType !== "Draft") return

       
      



    




        const errorSection = {
            1: "A1 - Personal Information",
            2: "A2 - Medical History/Dietary Restriction",
            3: "B1 - Method of Evaluation of Skills",
            4: "C - Employment History of the FDW"
        }


        const firstInvalidStep = Object.keys(stepManualErrors).find((key) => !stepManualErrors[key]);

        if (submitType == "Published") {
            if (firstInvalidStep && submitForce == false) {

                //setCurrentStep(parseInt(firstInvalidStep));
                setSubmitForce(true)
                setError("root", {
                    type: "server",
                    message: "Some fields need to be corrected on " + errorSection[parseInt(firstInvalidStep)] + ". If you wish to proceed, click 'Ignore Warnings and Submit'.",
                });
                return
            }
        }

const cleanedAges = Array.isArray(data.children_age)
  ? data.children_age.filter(age => age !== null && age !== undefined && age !== '')
  : [];

        const formData = new FormData();

        Object.keys(data).forEach((key) => {


            
             if (key === 'children_age') {


     const jsonAges = JSON.stringify(cleanedAges);
    formData.append('children_age', jsonAges);

    
  } else if (key === "imgprofile") {
   
                if (data.imgprofile && data.imgprofile.length > 0) {
                   
                    formData.set("imgprofile", data.imgprofile[0]);
                    //formData.set("imgprofile", data.imgprofile);
                }
            } else if (Array.isArray(data[key]) || typeof data[key] === "object") {

                formData.set(key, JSON.stringify(data[key]));

                if (key === "employment") {

                    // Convert object to array
                    //data.employment = Object.values(data.employment).filter(item => item !== null);
                    data.employment = Object.values(data.employment).filter(job => {
                        // 1) drop null/undefined entirely
                        if (job == null) return false;

                        // 2) check if *all* values are "" (or only whitespace)
                        const allBlank = Object.values(job).every(val =>
                            typeof val === "string"
                                ? val.trim() === ""
                                : val == null
                        );

                        // keep only those *not* allBlank
                        return !allBlank;
                    });

                    formData.set(key, JSON.stringify(data.employment));
                } else {
                    formData.set(key, JSON.stringify(data[key]));
                }
            } else if (data[key] !== undefined) {

                formData.set(key, data[key]);
            }
        });
        //console.log("Sending FormData:", formData);

        //if (!user.token) return
        let typeurl = ""


        if (user.type == "agency") typeurl = "/agency-biodata/"
        else if (user.type == "supplier") typeurl = "/supplier-biodata/"
        else return

        if (loadingForm || loadingFormDraft) return;
        submitType == "Published" ? setLoadingForm(true) : setLoadingFormDraft(true)

        formData.append("status", submitType);

    


/*
        let q=true
         if(q)return false*/
        try {
            let response;

            if (biodata) {
                response = await api.patch(typeurl + biodata.id + "/", formData
                    , {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );
            } else {
               
                response = await api.post(typeurl, formData
                    , {
                        headers: { "Content-Type": "multipart/form-data" },
                    }
                );
                setBiodata(response.data)
            }

        

            // Handle success based on status code
            if (response.status === 200 || response.status === 201) {

                console.log("Form submitted successfully!");

              

                if (submitType == "Published") {
                    reset();
                    setSubmitStatus(true)
                } else {
                    if (currentStep === stepSchemas.length) {

                        reset();
                        setSubmitStatus(true)
                        return
                    }

                    //this is for message periodic - dont use it to compare
                    setShowDraftSaved(true)


                    setCurrentStep((prev) => prev + 1);
                }




                // targetButtonRefs.current[0].click();
            }

        } catch (error) {
            const contentType = error.response?.headers?.['content-type'];
if (contentType && contentType.includes('text/html')) {
    const html = error.response.data;

    // Extract meaningful message using regex (basic version)
    const match = html.match(/<title>(.*?)<\/title>/i);
    if (match && match[1]) {
        errorMessage = `Server Error: ${match[1]}`;
    } else {
        errorMessage = "A server error occurred and the response was not in JSON format.";
    }
      setError("root", { type: "server", message: errorMessage });
      return
}
            console.error("Error submitting form:", error);
            let errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {

                Object.entries(error.response.data).forEach(([key, values]) => {
                    //if (key !== "token" && key !== "agency") {
                   
                    // errorMessage += `"${key}" ${values}\n`;
                    errorMessage += `${values}\n`;

                    //}
                });
            }

            // If no specific error was found, provide a default message
            if (!errorMessage) {

        errorMessage = `An unknown error occurred.\nError Code: ${responseCode}\n${error.message ?? ''}`;            }

            // Set the error message in React Hook Form
            setError("root", { type: "server", message: errorMessage });

        } finally {
            submitType == "Published" ? setLoadingForm(false) : setLoadingFormDraft(false)
        }
    };



    const jumpTab = async (stepTabIndex) => {
        const isValid = await trigger(); // Validate only current step
        //if (isValid) {
        setCurrentStep(stepTabIndex);
        // }
    };




    return (
        <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
            <Header onMenuClick={() => toggleMobileMenu()} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content container-fluid">
                    {/* Page Header */}
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>{t("Form Biodata")}</h5>
                        </div>
                    </div>
                    {/* /Page Header */}
                    <div className="row">
                        {/* Lightbox */}
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title mb-0">{biodata ? t("Edit") : t("Add")} {t("Biodata")}</h4>
                                </div>
                                <div className="card-body">
                                    {/*<div className="mb-4">
                                        <div className="row g-3">
                                            <div className="col-lg-6 col-md-12">
                                                <div className="card border-primary h-100">
                                                    <div className="card-header bg-primary text-white">
                                                        <h6 className="card-title mb-0 text-white">
                                                            <i className="fas fa-link me-2"></i>
                                                            {t("Extract from URL")}
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <URLBiodata extractedBiodata={(data)=>setURLBiodata(data)}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-12">
                                                <div className="card border-primary h-100">
                                                    <div className="card-header bg-primary text-white">
                                                        <h6 className="card-title mb-0 text-white">
                                                            <i className="fas fa-upload me-2"></i>
                                                            {t("Upload PDF Document")}
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <UploadBiodata extractedBiodata={(data)=>setUploadedFile(data)}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>*/}
                                    <div className="wizard">
                                        <ul className="nav nav-tabs justify-content-center" id="myTab" role="tablist">
                                            {steps.map((step, index) => (
                                                <li
                                                    key={step.id}
                                                    className="nav-item flex-fill"
                                                    role="presentation"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={step.title}
                                                >
                                                    <button
                                                        className={`nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center ${currentStep === step.id ? "active" : ""
                                                            }`}
                                                        onClick={() => jumpTab(step.id)}
                                                        id={`step${step.id}-tab`}
                                                        data-bs-toggle="tab"
                                                        role="tab"
                                                        aria-controls={`step${step.id}`}
                                                        aria-selected={currentStep === step.id}
                                                        ref={(el) => (targetButtonRefs.current[index] = el)}
                                                    >
                                                        <i className={step.icon} />
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    
                                        <FormProvider {...methods}>
                                            <form onSubmit={handleSubmit((data, e) => onSubmit(data, e))} encType="multipart/form-data" >
                                                {/* first sdection*/}


                                                <FormBiodata biodata={biodata} currentStep={currentStep}  methods={methods} />
                                                {submitStatus ? <>

                                                    <div className="row">
                                                        <div className="my-4">
                                                            <p className="alert alert-success biodata">

                                                                {t("The biodata has been successfully submitted with a status of")} <b>{submitTypeRef.current}</b>.{' '}
                                                                <Link to="/allbiodata" className="alert-link">
                                                                    {t("View All biodata")}
                                                                </Link>
                                                            </p>


                                                        </div>

                                                    </div>
                                                </>
                                                    :
                                                    <div className="d-flex">
                                                        {currentStep > 1 && <button className="btn btn-primary previous me-2" type="button" onClick={prevStep}>{t("Back")}</button>}
                                                        {currentStep < stepSchemas.length && (
                                                            biodata==null || biodata?.status === "Draft" ? (
                                                                <button
                                                                    type="submit"
                                                                    data-type="Draft"
                                                                    className="btn btn-primary next"
                                                                >
                                                                    {t("Next")}
                                                                    {loadingFormDraft && (
                                                                        <>
                                                                            , {t("Saving as Draft")}
                                                                            <i
                                                                                className="fa-solid fa-spinner fa-spin"
                                                                                style={{ margin: "0 10px" }}
                                                                            ></i>
                                                                        </>
                                                                    )}
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary next"
                                                                    onClick={nextStep}
                                                                >
                                                                    {t("Next")}
                                                                </button>
                                                            )
                                                        )}

                                                        {currentStep === stepSchemas.length && biodata?.status === "Draft" && <button type="submit" data-type="Draft" className="btn btn-primary mx-2" >{t("Save as Draft")}
                                                            {loadingFormDraft && <> {t("Saving")} <i className="fa-solid fa-spinner fa-spin" style={{ margin: "0 10px" }}></i></>}

                                                        </button>}
                                                        {currentStep === stepSchemas.length && (
                                                            (submitForce ?
                                                                <button type="submit" data-type="Published" className="btn btn-primary" >{t("Ignore Warnings and Submit")}
                                                                    {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ margin: "0 10px" }}></i>}
                                                                </button>
                                                                :
                                                                <button type="submit" data-type="Published" className="btn btn-primary" onClick={nextStep}>{t("Submit")}

                                                                    {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ margin: "0 10px" }}></i>}

                                                                </button>)

                                                        )}

                                                    </div>
                                                }
                                                {errors.root &&
                                                    <div className="row">
                                                        <div className="my-4">
                                                            <p className="text-primary biodata">
                                                                {errors.root?.message}

                                                            </p>

                                                        </div>

                                                    </div>}
                                                <div className="row">
                                                    <div className="my-4"></div>
                                                    <div style={{ maxWidth: '600px' }} className={`alert alert-success alert-dismissible fade ${showDraftSaved ? 'show' : ''}`} role="alert">
                                                        
                                                        {t("Biodata has been successfully saved as a draft.")}
                                                    </div> </div>

                                            </form>
                                        </FormProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* /Lightbox */}
                    </div>
                </div>
            </div>
        </div>
    );
};




export default BiodataForm;